import { createIllustration } from '@atlassian/jira-illustration/src/ui/index.tsx';
import type {
	AsImgProps,
	IllustrationFn,
	SVGViewBox,
} from '@atlassian/jira-illustration/src/ui/types.tsx';
import srcDark from '../../assets/incidents-preview-dark.svg';
import srcLight from '../../assets/incidents-preview.svg';

const Illustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
});

export default Illustration;

// for advanced use only
const viewBox: SVGViewBox = [0, 0, 216, 120];
export { viewBox };
